// extracted by mini-css-extract-plugin
export default {"notification-msg-details-modal":"style_notification-msg-details-modal__11bzq","notification-msg-content-details":"style_notification-msg-content-details__ThFPd"};